import Announcements from './Announcements';
import Divisions from './Divisions';
import Events from './Events';
import Prefs from './Prefs';
import Proofs from './Proofs';
import Questions from './Questions';
import Secure from './Secure';
import Songs from './Songs';
import UriMaps from './UriMaps';
import Users from './Users';
import Volumes from './Volumes';

export default {
	Announcements,
	Divisions,
	Events,
	Prefs,
	Proofs,
	Questions,
	Secure,
	Songs,
	UriMaps,
	Users,
	Volumes,
};